import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CLASSROOM_SOURCE_TYPES, CLASSROOM_TYPES } from "@/types/classrooms";
import { EDIT_CLASSROOM_ACTION } from "../ClassroomTileV2";
import { DeleteClassConfirmModal } from "@/components/DeleteClassConfirmModal";
import StandardModalV2 from "../shared/StandardModalV2";
import { Box, Button } from "@chakra-ui/react";
import { getClassroomDisplayName } from "@/utils/classroomUtils";
import { ClassroomOverviewDTO } from "@/stores/classroomStore_I";

export interface ClassroomEditV2Props {
	/** The classroom object containing details about the classroom. */
	classroom: ClassroomOverviewDTO;
	/** Indicates whether the modal is open. */
	open: boolean;
	/** Callback function to handle actions like cancel or delete. */
	handleAction: (action: string) => void;
}

export const ClassroomEditV2 = (props: ClassroomEditV2Props): JSX.Element => {
	const { t } = useTranslation();
	const [isDeleteOpen, setDeleteOpen] = useState(false);

	const renderActions = () => {
		const { classroom } = props;
		const sourceType = classroom.sourceType.toLowerCase();
		if (classroom.type.toLowerCase() === CLASSROOM_TYPES.CLASSROOM && sourceType.toLowerCase() === CLASSROOM_SOURCE_TYPES.LOCAL) {
			return (
				<div className="ClassroomEdit_modalButtons">
					<Button variant="dangerSubtle" onClick={() => handleAction(EDIT_CLASSROOM_ACTION.delete)} data-cy="delete">
						{t("classroomEdit.deleteClass")}
					</Button>
				</div>
			);
		}

		return <span />;
	};

	const handleAction = async (action: string) => {
		switch (action) {
			case EDIT_CLASSROOM_ACTION.cancel:
				setDeleteOpen(false);
				props.handleAction(action);
				break;
			case EDIT_CLASSROOM_ACTION.delete:
				setDeleteOpen(true);
				break;
			case EDIT_CLASSROOM_ACTION.deleteConfirmed:
				setDeleteOpen(false);
				props.handleAction(EDIT_CLASSROOM_ACTION.delete);
				break;
			default:
				break;
		}
	};

	const getDescription = () => {
		const classroomName = props.classroom.type === "CLASSROOM" ? props.classroom.name : props.classroom.description;
		// @ts-expect-error - Leaving as it was in the original code
		if (props.classroom?.personalisation?.displayName?.length > 0) {
			return classroomName;
		}
		return null;
	};

	return (
		<Box onClick={(event) => event.stopPropagation()}>
			<StandardModalV2
				title={t("classroomEdit.title", { name: getClassroomDisplayName(props.classroom) })}
				description={getDescription()}
				actions={renderActions()}
				// @ts-expect-error - Leaving as it was in the original code
				modal={true}
				open={props.open}
				close={() => handleAction(EDIT_CLASSROOM_ACTION.cancel)}
				bodyClass="classSettings_modal"
			>
				<div />
				<DeleteClassConfirmModal
					open={isDeleteOpen}
					classroomName={getClassroomDisplayName(props.classroom)}
					onDelete={() => handleAction(EDIT_CLASSROOM_ACTION.deleteConfirmed)}
					onCancel={() => setDeleteOpen(false)}
				/>
			</StandardModalV2>
		</Box>
	);
};
